<template>
  <div class="box" v-if="text !== null">
    <div class="b-1">
      <div>
        <h5 class="mb-3">{{ app_name }}</h5>
        <div v-html="text"></div>
      </div>
    </div>
    <div class="b-2">
      <img width="150px" :src="logo_url" alt="logo">
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutEstar",
  data: function () {
    return {
      text: null
    }
  },
  mounted() {
    axios.get('/api/webdriver/landpage', {params: {tags: 'sobre'}}).then(res => {
      this.text = res.data.data[0].content;
      if (this.text !== null) {
        this.$emit('show', true);
      }
    })
  },
  computed: {
    app_name: function () {
      return process.env.VUE_APP_NAME;
    },
    logo_url: function () {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
    }
  }
}
</script>

<style scoped>
.box {
  display: flex;

}

.b-1 {
  display: flex;
  align-items: center;
}

.b-1 > div {
  width: 100%;
  height: auto;
  padding-right: 100px;
}

.b-2 {
  width: 300px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

h5 {
  font-family: Roboto-Black;
  font-size: 24px;
  color: #58595B;
}

@media only screen and (max-width: 768px) {

  .box {
    margin-top: 0;
  }

  .b-2 {
    display: none;
  }

  .b-1 > div {
    width: 100%;
    height: auto;
    padding-right: 0;
  }

}
</style>
